// import {defineTool, EditorTool} from "./wireframe-editor";
// import {wireframe as api} from '../index';
//
// export default function downloader(wireframe: { project: string, variant: string }): EditorTool[] {
// 	let overwrite, commit, download;
//
// 	return [
// 		overwrite = defineTool('\uf09b', 'Original überschreiben')
// 			.onInvoke(iframe => {
// 				api.saveWireframe(iframe, wireframe, 'overwrite');
// 				overwrite.setIcon();
// 				overwrite.dispatch('end');
// 			}),
// 		commit = defineTool('\ueaf5', 'Neue Revision')
// 			.onInvoke(iframe => {
// 				api.saveWireframe(iframe, wireframe, 'commit');
// 				commit.setIcon();
// 				commit.dispatch('end');
// 			}),
// 		download = defineTool('\uf090', 'Herunterladen')
// 			.onInvoke(iframe => {
// 				const anchor = document.createElement('a');
//
// 				anchor.href = URL.createObjectURL(new Blob([iframe.contentDocument?.documentElement.outerHTML]));
// 				anchor.download = `${wireframe.project}-${wireframe.variant}.html`;
//
// 				anchor.click();
//
// 				download.dispatch('end');
// 			}),
// 	]
// }

import React from 'react';
import WireframeApi from "../../lib/wireframe";
import {iframeCx, useProjectNumber} from "./wireframe-editor";

interface SaveBtnPros {
	api: WireframeApi,
}

export function DownloadButton(props: SaveBtnPros) {
	const getIframe = React.useContext(iframeCx)!;
	const [project, variant] = useProjectNumber();

	return <button data-icon={'\uf090'} onClick={() => {
		const url = URL.createObjectURL(new Blob([getIframe().contentDocument.documentElement.outerHTML]));

		const a = document.createElement("a");

		a.href = url;
		a.download = `wireframe-${project}-${variant}-${new Date().toISOString()}.html`;

		a.click();
	}}>
		Herunterladen
	</button>
}

export function OverwriteButton(props: SaveBtnPros) {
	const getIframe = React.useContext(iframeCx)!;
	const [project, variant] = useProjectNumber();

	const [isProcessing, setIsProcessing] = React.useState(false);
	const overwrite = React.useCallback(() => {
		setIsProcessing(true);
		props.api.saveWireframe(getIframe(), {
			project: project,
			variant: variant
		}, 'overwrite')
			.catch(err => console.error(err))
			.then(() => setIsProcessing(false));
	}, [setIsProcessing, props.api, project, variant]);

	return <button data-icon={'\uf09b'} onClick={overwrite} disabled={isProcessing} data-loading={isProcessing}>
		Überschreiben
	</button>
}

export function CommitButton(props: SaveBtnPros) {
	const getIframe = React.useContext(iframeCx)!;
	const [project, variant] = useProjectNumber();

	return <button data-icon={'\ueaf5'} onClick={() => props.api.saveWireframe(getIframe(), {
		project: project,
		variant: variant
	}, 'commit')}>
		Neue Revision Erstellen
	</button>
}